import getV10APIs from './v1.0';
import getV11APIs from './v1.1';
import { mergeVersionsByTitle } from '../../../util/HelperFunctions';

const data = (userInfo) => {
  const v10APIs = getV10APIs(userInfo);
  const v11APIs = getV11APIs(userInfo);

  const children = [
    mergeVersionsByTitle('인증 토큰 발급', v10APIs),
    mergeVersionsByTitle('배송처 조회', v10APIs),
    mergeVersionsByTitle('HS코드 조회', v10APIs),
    mergeVersionsByTitle('로그 조회', v11APIs),
    mergeVersionsByTitle('매입처 조회', v10APIs),
    mergeVersionsByTitle('원산지 조회', v10APIs),
    mergeVersionsByTitle('택배사 코드 조회', v10APIs),
    mergeVersionsByTitle('공지사항 조회', v10APIs),
    mergeVersionsByTitle('API 대행사 설정', v10APIs),
  ].filter(Boolean);

  return { title: '공통', children };
};

export default data;
